import React from 'react';
import { ReminderFeed } from '~/components/Reminders';
import { usePatientService } from '~/services';

interface FocGapRemindersProps {
    focGapId: number;
    patientId: number;
    addReminderOpen?: boolean;
}

export function FocGapReminders({
    focGapId,
    patientId,
    addReminderOpen = false,
}: FocGapRemindersProps) {
    const { updateFocGap } = usePatientService();
    async function performAdd(description: string, dueDate: string) {
        await updateFocGap(focGapId, patientId, {
            tasks: [{ description, due_at: dueDate }],
        });
    }
    return (
        <ReminderFeed
            performAdd={performAdd}
            loadEntity={`foc_gap.id=${focGapId}`}
            addReminderOpen={addReminderOpen}
            isPCMView
        />
    );
}
